import {ethers} from "ethers";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { VXStrategyV1ABI as VXStrategyV1ABI } from "./abi/VXStrategyV1ABI";
import { VXStrategyBotConfig, VXStrategyScope } from "./VXSManagerV2Contract";


export class VXStrategyV1Contract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, VXStrategyV1ABI.GetABI(), provider);
    }

    async getStrategy(ofAddress:string): Promise<string>
    {
        return this._call("strategies", ofAddress);
    }

    async getConfig(ofAddress:string): Promise<VXStrategyBotConfig>
    {
        const result = await this._call("configs", ofAddress);
        if (!result) return;
        result.swapMaxSlippageIndex = this._toDecimal(result.swapMaxSlippageIndex);
        result.swapFrequencySeconds = parseInt(result.swapFrequencySeconds);
        result.splitFrequencySeconds = parseInt(result.splitFrequencySeconds);
        result.splitMinProfitAmount = this._toDecimal(result.splitMinProfitAmount);
        result.maxGasAmount = this._toDecimal(result.maxGasAmount);
        return result;
    }

    async configAsync(scope:VXStrategyScope): Promise<boolean>
    {
        const result = await this._send('config', 
            [
                "0",
                this._toWei(scope.uPLSInStake),
                "0",
                "0",

                scope.swapRouterV2,
                scope.swapPath,
                this._toWei(scope.swapMinPLSAmount),
                this._toWei(scope.swapMaxPLSAmount),

                this._toWei(scope.sendPLSIndex),
                scope.sendPLSReceiver,

                this._toWei(scope.bnsIndex),
                scope.sendAddress,

                scope.isBurnWithERC20Burn
            ]); 
        return result;
    }

    async configureBotAsync(config:VXStrategyBotConfig): Promise<boolean>
    {
        const result = await this._send('configureBot', 
            [
                this._toWei(config.swapMaxSlippageIndex), 
                config.swapFrequencySeconds+"",
                config.splitFrequencySeconds+"", 
                this._toWei(config.splitMinProfitAmount), 
                this._toWei(config.maxGasAmount)
            ]
            ); 
        return result;
    }
}